// Legacy types file - now re-exports from organized structure
// This file is kept for backward compatibility

export * from './types/index';

// Additional legacy types that may still be used
export interface DepthChartEntry {
  id?: string;
  team_id: string;
  player_id: string | null;
  position: string;
  depth: number;
  unit: string;
  color?: string;
  // No special_teams_unit needed - formation field handles Special Teams
  created_at?: string;
  updated_at?: string;
}

export interface FormationPosition {
  key: string;
  label: string;
  x: number;
  y: number;
  depths?: number;
}

export interface Formation {
  name: string;
  positions: FormationPosition[];
  description?: string;
  sport: string;
  unit: 'Offense' | 'Defense' | 'Special Teams';
}

export interface SportFormations {
  offensive: Formation[];
  defensive: Formation[];
  specialTeams: Formation[];
}

// Sport formats configuration
export const SportFormats: Record<string, string[]> = {
  Football: ['5v5', '6v6', '7v7', '8v8', '9v9', '11v11'],
  FlagFootball: ['4v4', '5v5', '6v6', '7v7', '8v8'],
  Basketball: ['1v1', '2v2', '3v3', '4v4', '5v5'],
  Baseball: ['9v9'],
  Softball: ['10v10', '9v9'],
  Soccer: ['3v3', '4v4', '5v5', '6v6', '7v7', '9v9', '11v11'],
  Volleyball: ['2v2', '3v3', '4v4', '6v6'],
  Hockey: ['3v3', '4v4', '5v5', '6v6'],
  Lacrosse: ['3v3', '4v4', '6v6', '7v7', '10v10', '12v12'],
};